import React, { useRef, useEffect, useState } from 'react';
import { ChatProps } from "@riskapp-it/mapo";

type ChatWidgetProps = ChatProps

export const ChatWidget: React.FC<ChatWidgetProps> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [chatElement, setChatElement] = useState<HTMLElement | null>(null);

  // Crea l'elemento personalizzato al mount
  useEffect(() => {
    const copy = containerRef.current;
    if (containerRef.current) {
      // Pulisci il contenitore
      containerRef.current.innerHTML = '';

      // Crea il Web Component
      const element = document.createElement('chat-widget');
      containerRef.current.appendChild(element);
      setChatElement(element);
    }

    // Pulizia alla smontatura
    return () => {
      if (copy) {
        copy.innerHTML = '';
      }
    };
  }, []);

  // Aggiorna le props quando cambiano
  useEffect(() => {
    if (chatElement) {
      // Separa le funzioni dalle altre props
      const { onCreateRoom, ...serializableProps } = props;

      // Passa le props serializzabili come attributo
      chatElement.setAttribute('data-props', JSON.stringify(serializableProps));

      // Indica se c'è un listener per onCreateRoom
      if (onCreateRoom) {
        chatElement.setAttribute('data-has-create-room-listener', 'true');

        // Rimuovi eventuali listener precedenti
        const oldListener = (chatElement as any)._createRoomListener;
        if (oldListener) {
          chatElement.removeEventListener('create-room', oldListener);
        }

        // Crea e aggiungi il nuovo listener
        const listener = async (event: Event) => {
          const customEvent = event as CustomEvent;
          const { room, resolve, reject } = customEvent.detail;

          try {
            await onCreateRoom(room);
            resolve();
          } catch (error) {
            reject(error);
          }
        };

        chatElement.addEventListener('create-room', listener);
        // Salva il riferimento per poterlo rimuovere dopo
        (chatElement as any)._createRoomListener = listener;
      } else {
        chatElement.removeAttribute('data-has-create-room-listener');
      }
    }
  }, [props, chatElement]);

  // Pulizia del listener alla smontatura
  useEffect(() => {
    return () => {
      if (chatElement) {
        const oldListener = (chatElement as any)._createRoomListener;
        if (oldListener) {
          chatElement.removeEventListener('create-room', oldListener);
          delete (chatElement as any)._createRoomListener;
        }
      }
    };
  }, [chatElement]);

  return <div ref={containerRef} />;
};